<script setup>
import {ref, onMounted} from "vue";

const props = defineProps({
    personalized: {
        type: Boolean,
        required: true,
    },
    message: {
        type: String,
        required: true
    },
    lead_id: {
        type: [String, Number],
        required: true
    },
})

const editingMessage = ref(false)
const _message = ref(props.message)

onMounted(() => {
    console.log('Component mounted with props:', {
        personalized: props.personalized,
        lead_id: props.lead_id,
        message: props.message
    })
})

const initPersonalization = async () => {
    try {
        console.log('Personalization button clicked')
        console.log('Props at click:', {
            lead_id: props.lead_id,
            message: props.message
        })

        if (!props.lead_id) {
            console.error('lead_id is missing')
            return
        }

        const response = await axios.post(route('assistant.personalizeEmail'), {
            lead_id: props.lead_id,
            message: props.message,
            subject: '',
        })

        console.log('Response:', response.data)
    } catch (error) {
        console.error('Error in personalization:', error)
    }
}

</script>

<template>
<div>

    <div class="flex justify-between -mx-4 md:-mx-6 border-b px-4 md:px-6 pb-2">
        <h5>{{ props.personalized ? 'Your personalized message' : 'Your base message' }}</h5>
    </div>

    <div class="py-4 -mx-4 md:-mx-6 md:px-6">
        <div class="flex items-center justify-between space-x-4">
            <span class="font-bold">Message</span>
            <container-with-tooltip
                alignment="center"
                tooltip-class="mb-1 bg-white text-xs px-1 py-0.5 rounded shadow-md text-xss"
            >
                <template #tooltip>
                    Copy to clipboard
                </template>

                <copyable-text
                    :show-url="false"
                    :copyable-text="_message"
                />
            </container-with-tooltip>
        </div>

        <input-editor
            v-if="editingMessage"
            v-model:content="_message"
        />
        <div
            v-else
            v-html="_message"
        >
        </div>
    </div>
</div>
</template>

<style scoped>

</style>
